import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface SettingsUsersTablesCellsCellDeleteSignature {
  Args: {
    row: {
      isLocked?: boolean;
      onDelete?: () => void;
    };
  };
}

const CellDelete: TOC<SettingsUsersTablesCellsCellDeleteSignature> = <template>
  <div>
    <PrismButton
      @buttonType="secondary"
      @icon="bin"
      @isDisabled={{@row.isLocked}}
      @onClick={{@row.onDelete}}
      @size="small"
      data-test-id="cell-delete-button"
    />
    {{#if @row.isLocked}}
      <PrismTooltip
        @side="left"
        @text={{t "useraccess_rights_locked_content"}}
        @title={{t "useraccess_rights_locked"}}
      />
    {{/if}}
  </div>
</template>;

export default CellDelete;
